import { Dialog } from '@headlessui/react';
import { Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import classNames from 'classnames';

interface SlideMenuProps {
  show?: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: string;
  qaDataName: string;
}

export const SlideMenu = ({
  show,
  onClose,
  width = 'w-96',
  children,
  qaDataName,
}: SlideMenuProps) => {
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog className="font-sans fixed inset-0 z-[60]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-1000 bg-opacity-50" />
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300 transform"
          enterFrom="opacity-0 translate-x-full"
          enterTo="opacity-100 translate-x-0"
          leave="ease-in duration-200 transform"
          leaveFrom="opacity-100 translate-x-0"
          leaveTo="opacity-0 translate-x-full"
        >
          <div
            className={classNames(
              'fixed bg-white top-0 right-0 bottom-0 flex flex-col p-6',
              [width],
            )}
            data-qa={qaDataName}
          >
            {children}
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};
